import React, { useEffect, useState } from "react";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import BlogAside from "../blog/blog-aside/BlogAside";
import BlogCommentForm from "./blog-comment-form/BlogCommentForm";
import BlogUsersComment from "./blog-users-comment/BlogUsersComment";
import { Helmet } from "react-helmet";
import { useGetBlogDetailsQuery } from "../products/productSlice";
import { useParams } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../server";
import { useTranslation } from "react-i18next";

// import blog1 from "../../assets/img/serviceList/cagliata.jpg";
// import blog2 from "../../assets/img/serviceList/Indian-Cereals.jpg";
// import blog3 from "../../assets/img/serviceList/Indian-Pulses.jpg";
// import blog4 from "../../assets/img/serviceList/gr5ikknbtygma4krpfai.png";
// import blog5 from "../../assets/img/serviceList/f454dq2nqgkt45dcladv.png";
// import blog6 from "../../assets/img/serviceList/jo1im9jkpkbst0of9sti.png";

import blog1 from "../../assets/img/broucher1.avif";
import blog2 from "../../assets/img/broucher2.avif";
import blog3 from "../../assets/img/broucher3.avif";
import blog4 from "../../assets/img/broucher4.avif";

const newsArray = [
  {
    id: 1,
    date: "02 Apr",
    url: blog1,
    shortInfo:
      "Cagliata is a soft, semi-finished cheese made from pasteurized cow's milk and rennet..",
    title: "Technical Articles",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 2,
    date: "02 Apr",
    url: blog2,
    category: "Blog",
    shortInfo:
      "Incorporating whole grains into your diet can have a profound impact on your health.",
    title: "Industry News",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 3,
    date: "02 Apr",
    url: blog3,
    category: "Blog",
    shortInfo: "I got my first premium designer bag when I was...",
    title: "Case Studies?",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 4,
    date: "02 Apr",
    url: blog4,
    shortInfo:
      "The Amazing Health Benefits of Broccoli: Why You Should Add It to Your Plate",
    title: "Safety and Compliance",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 5,
    date: "02 Apr",
    url: blog1,
    category: "Blog",
    shortInfo:
      "Celery is a low-calorie vegetable with a crisp texture and a wide range of health benefits",
    title: "New Technologies",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 6,
    date: "02 Apr",
    url: blog2,
    category: "Blog",
    shortInfo:
      "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
    title: "Maintenance and Overhaul",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 7,
    date: "02 Apr",
    url: blog3,
    category: "Blog",
    shortInfo:
      "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
    title: "The Importance of Maintenance",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
  {
    id: 8,
    date: "02 Apr",
    url: blog4,
    category: "Blog",
    shortInfo:
      "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
    title: "Blog",
    desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
    link: "Read more",
  },
];
function BlogDetail() {
  const params = useParams();

  const [data, setData] = useState(null);
  const [isLoading, setisLoading] = useState(false);

  const token = window.localStorage.getItem("token");
  const baseUrl = base_url();
  const getData = async () => {
    setisLoading(true);
    try {
      const res = await axios.get(`${baseUrl}blogs/${params.id}`, {
        withCredentials: true,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      });
      setisLoading(false);
      setData(res.data);
    } catch (error) {
      setisLoading(false);
      console.log("Fail to Load Blog Detail !");
    }
  };

  useEffect(() => {
    getData();
  }, []);
  const { t } = useTranslation();
  const [blogData, setBlogData] = useState(newsArray);
  const filterData = blogData.find((item) => {
    console.log(item.id === params.id);

    return item.id == params.id;
  });

  console.log("filterData", filterData);

  return (
    <>
      <Helmet>
        <title>Blog Detail | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title="Blog Detail" t={t} />
      <section className="blogDetailSec sectionPD">
        <div className="container">
          {isLoading && (
            <div className="preloaderCount">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-8">
              <div className="blogDetailInfo">
                <div className="blogDetailContent">
                  <figure className="currentBlogImg">
                    <img
                      src={filterData?.url}
                      alt="Blog"
                      className="img-fluid"
                    />
                  </figure>
                  <h4>{filterData.title}</h4>
                  <p>{filterData.desc}</p>
                </div>
                {/* <BlogUsersComment data={data} /> */}
                <BlogCommentForm />
              </div>
            </div>
            <div className="col-md-4">
              <BlogAside t={t} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
